import { LitElement } from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import "./kb-lang-selector.js";
import "./kb-header-parentpath.js";
import "./kb-ipc-cart-button.js";
import { Router } from "@vaadin/router";
import "@ui5/webcomponents/dist/Input.js";
import "@ui5/webcomponents/dist/BusyIndicator.js";
import "@ui5/webcomponents/dist/CheckBox";
import * as kblib from "lib/kblib.js";
import generateQueryParams from "../utils/generateQueryParams.js";
import generateQueryString from "../utils/generateQueryString.js";
import getProductTreeId from "../utils/getProductTreeId.js";
import { getValueFromTreeControlData, setProductTree } from "../lib/util.js";

class KbHeaderTemp extends LitElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this.requests = 0;
    PubSub.subscribe("requestout", this.requestout.bind(this));
    PubSub.subscribe("requestin", this.requestin.bind(this));
    PubSub.subscribe("error", this._handleHTTPError.bind(this));
    this.lastServerAccessTime = Date.now();
    this.idleLogoutTime = this.state.idletimeout_duration * 60000;
    this.checkIdleTime(this);
    this.controlDefs = this.state.panel_control_defs;
    this.controlValues = this.state.control_values;
    this.productTreeId = getProductTreeId(this.controlDefs);
    //this.myRender();
    window.addEventListener(
      "vaadin-router-location-changed",
      this._clearSearchTexOnPageChange.bind(this)
    );
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
    window.removeEventListener(
      "vaadin-router-location-changed",
      this._clearSearchTexOnPageChange
    );
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    this.controlDefs = this.state.panel_control_defs;
    this.controlValues = this.state.control_values;
    this.searchTerm = this.state.search_term?.searchterm || "";
    this.idleLogoutTime = this.state.idletimeout_duration * 60000;
    this.productTreeId = getProductTreeId(this.controlDefs);
    this.myRender();
  }

  myRender() {
    render(this.headerTemplate(), this.shadowRoot);
  }

  _itemFilterDisabled() {
    var retval = true;
    if (this.state.item) {
      switch (this.state.item.item.type) {
        case "category":
          retval = true;
          break;
        case "download":
          retval = true;
          break;
        case "directHelpset":
          retval = false;
          break;
        case "helpset":
          retval = false;
          break;
        case "folderview":
          retval = false;
          break;
      }
    }
    if (retval) {
      this.helpsetfilterchecked = false;
    }
    return retval;
  }

  headerTemplate() {
    return html`
      <style>
        #header {
          /* height: ${this.state.global_screen_specs.headerHeight}px; */
          border-bottom: 2px solid #e9ecee;
          background-color: var(--kb-header-background);
          background-image: var(--kb-backgroundimage-url);
          font-family: var(--kb-font-family-sans);
          font-size: var(--kb-body-font-size);
          position: relative;
          color: var(--kb-header-text-color);
          padding: 0 0.5rem 1rem;
          box-sizing: border-box;
        }
        #authlink {
          margin: 0;
          cursor: pointer;
          font-size: var(--kb-button-font-size-small);
        }
        #row1 {
          /* height: ${this.state.global_screen_specs.logoHeight}px;  */
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        #header-right {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          margin-left: 1rem;
        }

        #row2 {
          /* height: ${this.state.global_screen_specs.headerHeight -
          this.state.global_screen_specs.logoHeight}px;  */
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        }
        #logo {
          background-image: var(--kb-headerlogo-url);
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          height: var(--kb-headerlogo-height);
          width: var(--kb-headerlogo-width);
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
        }
        #searchbtn {
          cursor: pointer;
          padding: var(--kb-header-search-btn-padding);
          background: var(--kb-header-search-btn-bg-color);
          color: var(--kb-header-search-btn-text-color);
          border-width: var(--kb-header-search-btn-border-width, 0);
          border-style: solid;
          border-radius: var(--kb-header-search-icon-border-radius, 0);
          --sapButton_Active_Background: var(
            --kb-header-search-clearbtn-active-color
          );
          --_ui5_input_icon_pressed_color: var(
            --kb-header-search-clearbtn-active-color
          );
          --iron-icon-height: var(--kb-header-search-icon-height, 1rem);
          --iron-icon-width: var(--kb-header-search-icon-width, 2rem);
        }
        #closesearchicon {
          padding-right: 0.2rem;
          cursor: pointer;
          --iron-icon-height: 1.5rem;
          --iron-icon-width: 1.5rem;
        }
        #searchbox:focus {
          outline: none;
        }
        #searchbox {
          padding-left: 0.5rem;
          font-size: var(--kb-header-search-fontsize, 1.25rem);
          border-radius: var(--kb-header-search-border-radius);
          border: var(--kb-header-search-border, none);
          height: var(--kb-header-search-height);
          min-width: var(--kb-header-search-minwidth);
          width: 100%;
          background-color: var(--kb-header-search-background-color);
          --sapField_TextColor: var(--kb-header-search-text-color);
          --sapField_BorderColor: var(--kb-header-search-border-color);
        }

        .search-slot {
          width: 100%;
        }

        #busy {
          position: absolute;
          top: 9px;
          left: 50%;
          color: var(--kb-on-primary-color);
        }
        ui5-checkbox {
          margin-right: 0.5rem;
          --_ui5_checkbox_wrapper_padding: 0rem;
          --_ui5_checkbox_width_height: 0;
          --sapContent_LabelColor: var(--kb-on-primary-color);
        }

        show-mobile {
          display: block;
        }

        ui5-checkbox {
          --_ui5_checkbox_inner_width_height: 1rem;
          --_ui5_checkbox_inner_width_height: 1rem;
          /* --_ui5_checkbox_icon_size: ; */
        }

        .searchhelpsetcheckbox-text {
          font-size: 0.75rem;
        }

        .checkbox-container {
          display: flex;
          align-items: center;
          margin-bottom: 0;
        }

        .box-container {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: baseline;
        }

        .box-2 {
          display: flex;
          flex-direction: row-reverse;
          align-items: flex-start;
          width: 100%;
        }

        .logout-container {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .search {
          box-sizing: border-box;
          display: flex;
          align-items: center;
          max-width: 30rem;
          width: 100%;
          justify-content: center;
        }

        .hide-mobile {
          display: none;
        }

        .breadcrumb-holder {
          display: inline;
        }

        #toctoggle {
          width: 1.35rem;
          margin: 0.5rem 0.5rem 0 0px;
        }

        @media only screen and (min-width: 640px) {
          #header {
            padding: 0 0.5rem 1rem;
            height: var(--kb-header-height, 6rem);
          }

          .hide-mobile {
            display: flex;
          }

          .hide-desktop {
            display: none;
          }

          .box-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-end;
          }

          .box-2 {
            flex-direction: row-reverse;
            justify-content: center;
            align-items: center;
            width: 50%;
          }

          .box-3 {
            display: flex;
            width: 5rem;
            justify-content: space-between;
          }

          #toctoggle {
            display: none;
          }
        }

        @media only screen and (min-width: 740px) {
          #header {
            padding: 1rem 2rem 1rem;
          }
        }
      </style>
      <custom-header>
        <div id="logo" slot="logo" @click="${this._goHome.bind(this)}"></div>
        <kb-lang-selector slot="lang-selector"></kb-lang-selector>

        <div slot="parentpath" class="breadcrumb-holder">
          <kb-header-parentpath></kb-header-parentpath>
        </div>

        <div slot="search-bar" class="search-slot">
          <div id="search" class="search">
            <ui5-input
              id="searchbox"
              show-clear-icon
              @keyup="${this.checkEnterKey.bind(this)}"
              placeholder="${this.string["_search"]}"
              value="${this._getSearchTermFromURL() || this.searchTerm}"
            >
            </ui5-input>
            <iron-icon
              id="searchbtn"
              icon="vaadin:search"
              @click="${this.handleSearchButtonClick.bind(this)}"
            ></iron-icon>
          </div>

          ${(this.state?.item?.item?.type === "helpset" ||
            this.state?.item?.item?.type === "directHelpset") &&
          !window.location.pathname.includes("kbsearch") &&
          !window.location.pathname.includes("pubsearch")
            ? html` <div class="checkbox-container hide-mobile">
                <ui5-checkbox
                  id="searchhelpsetcheckbox"
                  ?disabled="${this._itemFilterDisabled()}"
                  @change="${this._itemFilterChange.bind(this)}"
                  ?checked="${true}"
                ></ui5-checkbox>
                <span class="searchhelpsetcheckbox-text"
                  >${this.string["_currenthelpsetsearch"]}</span
                >
              </div>`
            : null}
        </div>

        <div
          slot="logout"
          @click=${this._logout}
          class="logout-container hide-mobile"
        >
          <iron-icon icon="vaadin:sign-out"></iron-icon>
          ${this.state?.kb_user?.username
            ? html`<span style="min-width:2rem;"
                >${this.state.kb_user.username}</span
              >`
            : html`<span style="height:1rem;width:2rem;"></span>`}
        </div>
      </custom-header>
    `;
  }

  async _clearSearch() {
    var searchbox = this.shadowRoot.querySelector("#searchbox");
    storeInstance.dispatch("setState", {
      property: "control_values",
      value: {},
    });
    if (searchbox.value || window.location.search !== "") {
      if (window.location.pathname.toLowerCase().includes("/kbsearch")) {
        history.pushState(null, null, "/kb/" + this.state.langCode);
        Router.go("/kb/" + this.state.langCode + "/kbsearch");
      }
      searchbox.value = "";
      storeInstance.dispatch("setState", {
        property: "search_term",
        value: { searchterm: "" },
      });
    }
    history.pushState(null, null, "/kb/" + this.state.langCode);
    Router.go("/kb/" + this.state.langCode + "/kbsearch");
  }

  _getSearchTerm() {
    var retval = "";
    if (this.state.search_term) {
      if (this.state.search_term.item == "ROOT") {
        retval = this.state.search_term.searchterm || "";
      }
    }
    return retval;
  }

  checkEnterKey(e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      this.handleSearchButtonClick();
    }
  }

  _getSearchTermFromURL() {
    let queryParams = new URLSearchParams(window.location.search);
    this._getSearchTerm();
    if (queryParams.has("searchTerm")) {
      return queryParams.get("searchTerm");
    } else {
      return "";
    }
  }

  getHelpsetIdFromURL() {
    let queryParams = new URLSearchParams(window.location.search);
    this._getSearchTerm();
    if (queryParams.has("helpsetId")) {
      return queryParams.get("helpsetId");
    } else {
      return "";
    }
  }

  resetPagination() {
    storeInstance.dispatch("setState", {
      property: "current_results_page",
      value: 1,
    });
  }

  resetPropertyFilter() {
    storeInstance.dispatch("setState", {
      property: "control_values",
      value: {},
    });
  }

  isUserOnSearchPage() {
    return (
      window.location.href.includes("kbsearch") ||
      window.location.href.includes("pubsearch")
    );
  }

  processSearchTerm(searchTerm) {
    if (searchTerm) {
      storeInstance.dispatch("setState", {
        property: "search_term",
        value: {
          searchterm: searchTerm,
        },
      });
    } else {
      storeInstance.dispatch("setState", {
        property: "search_term",
        value: { item: "ROOT", searchterm: "" },
      });
      storeInstance.dispatch("setState", {
        property: "filter_term",
        value: null,
      });
    }
  }

  _itemFilterChange(e) {
    if (e.currentTarget.checked) {
      storeInstance.dispatch("setState", {
        property: "filter_helpset_id",
        value: this.state?.item?.item?.externalId,
      });
    } else {
      storeInstance.dispatch("setState", {
        property: "filter_helpset_id",
        value: "",
      });
    }
  }

  processUserLocation(searchTerm) {
    if (this.isUserOnSearchPage()) {
      return generateQueryParams(this.controlValues, searchTerm);
    } else {
      this.resetPropertyFilter();
      return generateQueryParams({}, searchTerm);
    }
  }

  async updateTreeControlData() {
    let treeData = await kblib.getControlDefData(this.productTreeId);
    let controlData = this.state.control_def_data_array;
    let index = controlData.findIndex(
      (data) => data.controlDefId === this.productTreeId
    );
    controlData[index] = treeData;
    storeInstance.commit("setControlDefData", controlData);
  }

  async processWithinHelpsetSearch(searchParams) {
    let checkbox = this.shadowRoot.querySelector("#searchhelpsetcheckbox");
    if (checkbox?.checked) {
      storeInstance.dispatch("setState", {
        property: "filter_helpset_id",
        value: this.state?.item?.item?.externalId,
      });
      searchParams.set(
        `${this.productTreeId}`,
        this.state?.item?.item?.externalId
      );
      searchParams.set("helpsetId", this.state?.item?.item?.externalId);
      await this.updateTreeControlData();
      await setProductTree(this.state?.item?.item?.externalId);
    } else {
      storeInstance.dispatch("setState", {
        property: "filter_helpset_id",
        value: "",
      });
    }
    return searchParams;
  }

  goToNewResults(searchParams) {
    let searchURL = `/kb/${this.state.langCode}/kbsearch`;
    let queryString = searchParams.toString();
    searchURL += queryString ? `?${queryString}` : "";
    history.pushState(null, null, searchURL);
    storeInstance.dispatch("getPanelSearchResults");
    Router.go(searchURL);
  }

  async handleSearchButtonClick() {
    let searchbox = this.shadowRoot.querySelector("#searchbox");
    let searchTerm = searchbox.value;
    let searchParams = new URLSearchParams();
    searchParams = this.processUserLocation(searchTerm);
    searchParams = await this.processWithinHelpsetSearch(searchParams);
    this.processSearchTerm(searchTerm);
    this.resetPagination();
    this.goToNewResults(searchParams);
  }

  //deprecated
  _search() {
    var searchbox = this.shadowRoot.querySelector("#searchbox");
    let searchUrl = `/kb/${this.state.langCode}/kbsearch`;
    storeInstance.dispatch("setState", {
      property: "current_results_page",
      value: 1,
    });
    if (
      window.location.href.includes("kbsearch") ||
      window.location.href.includes("pubsearch")
    ) {
      searchUrl += `?${generateQueryString(
        this.controlValues,
        searchbox.value
      )}`;
    } else {
      searchUrl += `?${generateQueryString({}, searchbox.value)}`;
      storeInstance.dispatch("setState", {
        property: "control_values",
        value: {},
      });
    }
    if (searchbox.value) {
      if (this.state.filter_helpset_id) {
        searchUrl = searchUrl + "/" + this.state.item.item.externalId;
      }
      history.pushState(null, null, searchUrl);
      Router.go(searchUrl);
      storeInstance.dispatch("setState", {
        property: "search_term",
        value: {
          searchterm: searchbox.value,
        },
      });
      storeInstance.dispatch("getPanelSearchResults");
      // storeInstance.dispatch("setState", {property: "filter_term" ,value: null } )  //clear filter if doing a search
    } else {
      storeInstance.dispatch("setState", {
        property: "search_term",
        value: { item: "ROOT", searchterm: "" },
      });
      storeInstance.dispatch("setState", {
        property: "filter_term",
        value: null,
      });
      history.pushState(null, null, searchUrl);
      storeInstance.dispatch("getPanelSearchResults");
      Router.go(searchUrl);
    }
    // storeInstance.dispatch("setState", {property: "filter_term" ,value: null } )  //clear filter if doing a search
  }

  _logout(e) {
    storeInstance.dispatch("logout");
  }

  _reset() {
    storeInstance.dispatch("logout");
    //console.log("reseting")
  }
  _goHome() {
    Router.go("/kb/" + this.state.langCode);
    this._clearSearchText();
  }

  _clearSearchTexOnPageChange() {
    if (
      !window.location.pathname.includes("kbsearch") &&
      !window.location.pathname.includes("pubsearch")
    ) {
      this._clearSearchText()
    }
  }

  _clearSearchText() {
    let searchbox = this.shadowRoot.querySelector("#searchbox");
    if (searchbox.value) {
      searchbox.value = "";
      storeInstance.dispatch("setState", {
        property: "search_term",
        value: { searchterm: "" },
      });
    }
  }

  _handleHTTPError(msg, data) {
    var subMsg = msg.split(".")[1];
    switch (subMsg) {
      case "unauthorized":
        storeInstance.dispatch("setState", {
          property: "error_dialog_open",
          value: { callback: this._logout.bind(this), error: data },
        });
        break;
      case "forbidden":
        storeInstance.dispatch("setState", {
          property: "error_dialog_open",
          value: { callback: null, error: data },
        });
        break;
      case "serverError":
        storeInstance.dispatch("setState", {
          property: "error_dialog_open",
          value: { callback: this._reset.bind(this), error: data },
        });
        break;
      case "other":
        storeInstance.dispatch("setState", {
          property: "error_dialog_open",
          value: { callback: this._reset.bind(this), error: data },
        });
        break;
    }
  }

  requestout() {
    this.requests++;
    this.startProgressbar();
  }

  requestin() {
    this.requests--;
    this.active = "";
    if (this.requests == 0) {
      this.stopProgressbar();
    }
    this.lastServerAccessTime = Date.now();
  }

  checkIdleTime(that) {
    if (Date.now() - that.lastServerAccessTime >= that.idleLogoutTime) {
      //&& this.state.kb_user
      this._reset();
    } else {
      setTimeout(
        function () {
          that.checkIdleTime(that);
        }.bind(that),
        60000
      );
    }
  }

  startProgressbar() {
    if (!this.busy) {
      this.busy = this.shadowRoot.querySelector("#busy");
    }
    try {
      this.busy.active = true;
    } catch (err) {}
  }

  stopProgressbar() {
    if (!this.busy) {
      this.busy = this.shadowRoot.querySelector("#busy");
    }
    try {
      this.busy.active = false;
    } catch (err) {}
  }
}

customElements.define("kb-header-temp", KbHeaderTemp);
